import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from "react-router-dom";
import {
    Form,
    FormGroup,
    Label,
    Input,
    Button,
    Row,
    Col,
    CustomInput,
} from 'reactstrap';
import 'react-notifications/lib/notifications.css';
import { NotificationContainer, NotificationManager } from 'react-notifications';
import { usePost } from 'hooks/usePost';
import { useFetch } from 'hooks/useFetch';  

export default function CouponDetails() {
    const { couponId } = useParams();
    const { data: coupon } = useFetch(process.env.REACT_APP_DJANGO_SERVER_URL+"/api/getCoupon/"+couponId);
    const navigate = useNavigate();
    const [couponName, setCouponName] = useState('');
    const [couponDesc, setCouponDesc] = useState('');
    const [couponDiscount, setCouponDiscount] = useState('');
    const [isCouponActive, setIsCouponActive] = useState('');
    const [isPercentDiscount, setIsPercentDiscount] = useState('');
    const [couponCode, setCouponCode] = useState('');
    const [couponData, setCouponData] = useState(null);
    const {postData,resData}=usePost();
    console.log('hie ',couponId)
    const handleSubmit = (event) => {
    event.preventDefault();
    // Add your logic to handle form submission here
    if (!couponData.coupon_name) {
        NotificationManager.error('Please fill in the coupon name', '', 3000);
        return;
    }
    if (couponData.is_percent_discount==='') {
        NotificationManager.error('Please specify if the discount is in percentage', '', 3000);
        return;
    }
    
    if (!couponData.coupon_discount) {
        NotificationManager.error('Please fill in the coupon discount', '', 3000);
        return;
    }

    if (!couponData.coupon_code) {
        NotificationManager.error('Please fill in the coupon code', '', 3000);
        return;
    }
    
    if (couponData.is_active==='') {
        NotificationManager.error('Please specify if the coupon is active', '', 3000);
        return;
    }
    const formData = {
        coupon_name : couponData.coupon_name,
        coupon_description : couponData.coupon_description,
        coupon_discount : Number(couponData.coupon_discount),
        is_active : Number(couponData.is_active),
        is_percent_discount : Number(couponData.is_percent_discount),
        coupon_code: couponData.coupon_code,
        archive : 0
    };
    console.log(formData);
        postData(process.env.REACT_APP_DJANGO_SERVER_URL+"/api/updateCoupon/"+Number(couponId),formData,"PUT");
    };

    useEffect(() => {
        if(resData && resData.status===200){
            NotificationManager.success('Coupon Updated Successfully!', '', 2000);
            setTimeout(() => {
                navigate('/admin/view-all-coupons');
            }, 1000);
        }
    }, [resData])

    useEffect(() => {
        if(coupon){
            setCouponData(coupon)
        }
    
    }, [coupon])
    
    

    return (
        <div className="container pt-7">
        <NotificationContainer />
            {couponData && <Form onSubmit={handleSubmit}>
                <h6 className="heading-small text-muted mb-4">Coupon Information</h6>
                <div className="pl-lg-4">
                    <Row>
                        <Col lg="6">
                            <FormGroup>
                                <Label for="couponName">Coupon Name</Label>
                                <Input
                                type="text"
                                id="couponName"
                                placeholder="Coupon Name"
                                name="couponName"
                                onChange={(e) => setCouponData({...couponData,coupon_name:e.target.value})}
                                value={couponData.coupon_name}
                                className="form-control-alternative"
                                />
                            </FormGroup>
                        </Col>
                        <Col lg="6">
                            <FormGroup>
                                <Label for="couponDesc">Coupon Description</Label>
                                <Input
                                type="text"
                                id="couponDesc"
                                placeholder="Coupon Description"
                                name="couponDesc"
                                onChange={(e) => setCouponData({...couponData,coupon_description:e.target.value})}
                                value={couponData.coupon_description}
                                className="form-control-alternative"
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col lg="6">
                            <FormGroup>
                                <Label for="exampleCheckbox">
                                Create coupon with percentage discount 
                                </Label>
                                <div>
                                <CustomInput
                                    type="radio"
                                    id="yespercent"
                                    name="isPercentDiscount"
                                    label="Yes"
                                    inline
                                    value="1"
                                    checked = {couponData.is_percent_discount===true?'checked':''}
                                    onChange={() => setCouponData({...couponData,is_percent_discount:true})}
                                />
                                <CustomInput
                                    type="radio"
                                    id="nopercent"
                                    name="isPercentDiscount"
                                    label="No"
                                    inline
                                    value="0"
                                    checked = {couponData.is_percent_discount===false?'checked':''}
                                    onChange={() => setCouponData({...couponData,is_percent_discount:false})}
                                />
                                </div>
                            </FormGroup>
                        </Col>
                        <Col lg="6">
                            <FormGroup>
                                <Label for="couponDiscount">Coupon Discount</Label>
                                <Input
                                type="text"
                                id="couponDiscount"
                                placeholder="Coupon Discount"
                                name="couponDesc"
                                value={couponData.coupon_discount}
                                onChange={(e) => setCouponData({...couponData,coupon_discount:e.target.value})}
                                className="form-control-alternative"
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col lg="6">
                            <FormGroup>
                                <Label for="couponDiscount">Coupon Code</Label>
                                <Input
                                type="text"
                                id="couponCode"
                                placeholder="Coupon Code"
                                name="couponCode"
                                value={couponData.coupon_code}
                                onChange={(e) => setCouponData({...couponData,coupon_code:e.target.value})}
                                className="form-control-alternative"
                                />
                            </FormGroup>
                        </Col>
                        <Col lg="6">
                            <FormGroup>
                                <Label for="exampleCheckbox">Activate Coupon</Label>
                                <div>
                                <CustomInput
                                    type="radio"
                                    id="yes"
                                    name="isCouponActive"
                                    label="Yes"
                                    inline
                                    value="1"
                                    checked = {couponData.is_active===true?'checked':''}
                                    onChange={() => setCouponData({...couponData,is_active:true})}
                                />
                                <CustomInput
                                    type="radio"
                                    id="no"
                                    name="isCouponActive"
                                    label="No"
                                    inline
                                    value="0"
                                    checked = {couponData.is_active===false?'checked':''}
                                    onChange={() => setCouponData({...couponData,is_active:false})}
                                />
                                </div>
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Button type="submit" color="primary">
                            Update Coupon
                        </Button>
                    </Row>                          
                </div>
            </Form>}
        </div>
    );
}
